import { Status, TimeType, PriorityType, StatusType } from "src/constants/taskmanagement";
import { ITask } from "../types/taskManager";

// sort task Data
export interface ISortData {
  task?: boolean;
  date: boolean;
  priority: boolean;
}


export interface IFilterData {
	[key: string]: string;
	DateRange: string;
	Status: string;
	Priority: string;
	TaskName: string;
}

export const filterTaskData = (tasks: ITask[], filterData: IFilterData) => {
  // checking for filter criteria
  const isTaskName = filterData.TaskName !== "" && filterData.TaskName !== "All";
  const isPriority = filterData.Priority !== "" && filterData.Priority !== "All";
  const isStatus = filterData.Status !== "" && filterData.Status !== "All";
  const isDate = filterData.DateRange !== "" && filterData.DateRange !== "All";

  // task filter
  if (isTaskName || isPriority || isStatus || isDate) {
    const result = tasks.filter((task) => {
      const satisfiesTaskName = !isTaskName || task.name === filterData.TaskName;
      const satisfiesPriority = !isPriority || task.priority === filterData.Priority;
      const satisfiesStatus = !isStatus || task.status === filterData.Status;
      const satisfiesDate = !isDate || filterDataByTimeType(task, filterData.DateRange);

      // must satisfy all selected filters
      return satisfiesTaskName && satisfiesPriority && satisfiesStatus && satisfiesDate;
    });
    return result;
  } else {
    // for no filter criteria, exclude complete here.
    const data = tasks.filter((task: ITask) => task.status !== Status.Done);
    return data;
  }
};

//filter for timeType
const filterDataByTimeType = (task: ITask, timeType: string) => {
	const currentDate = new Date(); // Get current date

	switch (timeType) {
		//case 1
		case "Current Month":
			const currentMonthStart = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth(),
				1
			);
			return new Date(task?.createdAt) >= currentMonthStart;

		//case 2
		case "Last 3 Months":
			const threeMonthsAgo = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth() - 3,
				currentDate.getDate()
			);
			return new Date(task?.createdAt) >= threeMonthsAgo;

		//case 3
		case "Last Year":
			const lastYearStart = new Date(
				currentDate.getFullYear() - 1,
				currentDate.getMonth(),
				currentDate.getDate()
			);
			return new Date(task?.createdAt) >= lastYearStart;

		default:
			return task;
	}
};


export const sortTaskData = (item: ITask[], isSortData: ISortData) => {
  let data: ITask[] = [];
  if (item?.length > 0) {
    let result = item.slice().sort((a: ITask, b: ITask) => {
      const priorityOrder = ["High", "Medium", "Low"];

      //if date and priority sort both is true
      if (isSortData.date && isSortData.priority) {
        return (
          (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any) &&
          priorityOrder.indexOf(a.priority) -
            priorityOrder.indexOf(b.priority)
        );
      }
      //if only date sorting is true
      else if (isSortData.date) {
        return (
          (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any)
        );
      }
      //if only priority sorting is true
      else if (isSortData.priority) {
        return (
          priorityOrder.indexOf(a.priority) -
          priorityOrder.indexOf(b.priority)
        );
      }
      //else just sort in descending order with createdAt property
      else {
        return 0;
      }
    });
    data = [...result];
    return data;
  }

  return item;
};

/**
 * Extract unique task names from a list of tasks.
 */
export function getUniqueTaskNames(tasks: ITask[]): string[] {
  return Array.from(new Set(tasks.map(task => task.name))).sort((a, b) => a.localeCompare(b));
}

/**
 * Update the filter data array with unique task names for the TaskName filter.
 * @param filterData The original filter data array
 * @param uniqueTaskNames The unique task names to set as options
 */
export function updateTaskNameFilterData(
  filterData: { label: string; data: string[] }[],
  uniqueTaskNames: string[]
): { label: string; data: string[] }[] {
  return filterData.map(filter => {
    if (filter.label === "TaskName") {
      return { ...filter, data: ["", ...uniqueTaskNames] };
    }
    return filter;
  });
}

/**
 * Returns a default FilterData array, with TaskName options set to uniqueTaskNames.
 */
export function getDefaultFilterData(uniqueTaskNames: string[]): { label: string; data: string[] }[] {
  return [
    { label: "TaskName", data: ["All", ...uniqueTaskNames] },
    { label: "DateRange", data: TimeType },
    { label: "Priority", data: PriorityType },
    { label: "Status", data: StatusType },
  ];
}